import ArticleLink from '../models/ArticleLink';
import React from 'react';
import BlogSections from '../BlogSections';
import Link from '@/components/Link';

export const blogEndpoint = 'articles';

interface PrimaryTaxonomyItemLinkProps {
  articleLink: ArticleLink;
  hidden?: boolean;
  className?: string;
}

export default class PrimaryTaxonomyItemLink extends React.PureComponent<PrimaryTaxonomyItemLinkProps> {
  render() {
    return this.props.articleLink.taxonomyItemSlug ? (
      <Link
        href={`/${blogEndpoint}/${BlogSections.generalResults}/${this.props.articleLink.primaryTaxonomySlug}/${this.props.articleLink.taxonomyItemSlug}`}
      >
        <a className={`category-link ${this.props.hidden ? 'hidden' : ''} ${this.props.className || ''}`}>
          <span>{this.props.articleLink.taxonomyItemName}</span>
        </a>
      </Link>
    ) : null;
  }
}
